// Vises i stedet for skjemaer bare leder skal bruke (skille i UI, se employeeAccess.js).
import React from 'react';
import { Link } from 'react-router-dom';

export default function BareLeder({ tekst = 'Bare en leder kan gjøre dette.', tilbake = '/employees' }) {
  return (
    <div className="max-w-xl mx-auto mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-bold text-slate-900">Bare for leder</h1>
      <p className="mt-2 text-slate-700">{tekst} Velg en leder øverst, eller be en leder om hjelp.</p>
      <Link to={tilbake} className="mt-4 inline-block font-semibold text-indigo-700 hover:underline">Tilbake</Link>
    </div>
  );
}
